type Size = 'xs' | 'sm' | 'md' | 'lg';

export function Spinner({ size = 'md', className }: { size?: Size; className?: string }) {
  return (
    <span
      className={`spinner spinner-${size} ${className ?? ''}`.trim()}
      role="status"
      aria-label="Cargando"
    />
  );
}
